import { render, staticRenderFns } from "./customSelfList.vue?vue&type=template&id=63e84f62&scoped=true"
import script from "./customSelfList.vue?vue&type=script&lang=ts"
export * from "./customSelfList.vue?vue&type=script&lang=ts"
import style0 from "./customSelfList.vue?vue&type=style&index=0&id=63e84f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e84f62",
  null
  
)

export default component.exports